import styled from 'styled-components';
import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { RELATIVE_DATE_PRESETS } from 'ui/datePicker/helpers';
import { ChevronDown24 } from 'ui/icons/aurora/24px/ChevronDown24';
import { ALIGNMENT, Menu } from 'ui/menu';
import { useMissionControlContext } from 'modules/missionControl/contexts/MissionControlContext';
import { convertPresetToDateRange } from 'modules/missionControl/utils/conversions';

const SUPPORTED_DATE_PRESETS = ['TODAY', 'PAST_3_DAYS', 'PAST_7_DAYS', 'PAST_30_DAYS'];

const StyledButton = styled(Button)`
  white-space: nowrap;
`;

const options = (Object.keys(RELATIVE_DATE_PRESETS) as Array<keyof typeof RELATIVE_DATE_PRESETS>)
  .filter((key) => SUPPORTED_DATE_PRESETS.includes(key))
  .map((key) => ({
    id: key,
    label: RELATIVE_DATE_PRESETS[key].menuLabel,
  }));

export const DateFilterMenu = () => {
  const { dateRangePreset, setDateRangePreset, setStartDate, setEndDate, trackFilters } =
    useMissionControlContext();

  const handleFilterOptionChange = (datePreset: string) => {
    const { startDate, endDate } = convertPresetToDateRange(datePreset);

    setDateRangePreset(datePreset);
    setStartDate(startDate);
    setEndDate(endDate);
    trackFilters({
      datePreset,
    });
  };

  return (
    <Menu
      options={options}
      defaultSelectedOptionIds={[dateRangePreset]}
      verticalAlignment={ALIGNMENT.DOWN}
      horizontalAlignment={ALIGNMENT.LEFT}
      handleSelectionChange={handleFilterOptionChange}
    >
      <StyledButton variant={BUTTON_VARIANTS.GHOST} size={BUTTON_SIZES.LARGE}>
        {RELATIVE_DATE_PRESETS[dateRangePreset as keyof typeof RELATIVE_DATE_PRESETS].menuLabel}
        <ChevronDown24 />
      </StyledButton>
    </Menu>
  );
};
